import Dinero from "dinero.js";

import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Table } from "semantic-ui-react";

import { COST_FORMAT } from "../config.js";

import { secondsToString } from "../../utils/timeUtils.js";
import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class InvoiceResourceRow extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    icon: PropTypes.object,
    showUsage: PropTypes.bool.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    showUsage: true
  };

  render() {
    const { data, icon, showUsage, copy } = this.props;

    if (!data) return null;

    const charge = Dinero({
      amount: Math.round(data.charge.value), // this should be rounded by the api
      currency: data.charge.currency
    });

    return (
      <Table.Row key={data["@id"]} textAlign="center">
        <Table.Cell textAlign="left">{icon}</Table.Cell>
        {showUsage && (
          <Table.Cell collapsing>{`${secondsToString(
            data.usage.value,
            copy("usage.time.abbr")
          )}`}</Table.Cell>
        )}
        <Table.Cell textAlign="left" collapsing>{` ${charge.toFormat(
          COST_FORMAT
        )}`}</Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(InvoiceResourceRow);
